import React from 'react'
import { CaseResponse } from './Queries'
import {
  CaseType,
  CaseSubType,
  REASON_CODE_CONFIG,
  VI18_REASON_CODE,
  VI19_REASON_CODE,
  VI19_SUB_REASON_CODES,
  RTVS_MULTIPLE_REASONS_CODE_TEXT,
  RTVS_DOC_PREFIX,
} from '../Services/ConstantData'
import { Section, SectionItem } from './Section'
import { BottomBorderDiv } from './SynergyDivComponent'
import { getLatestReopenDetail } from './ReopenUtils'

interface MainProp {
  heading: string
  disputeDetails: CaseResponse | undefined
  isVendor?: boolean
}

const EditDisputeDetails: React.FC<MainProp> = ({
  heading,
  disputeDetails,
  isVendor,
}) => {
  const claimFiling = disputeDetails?.caseType === CaseType.INTERNALPROCESSING
  const request = disputeDetails?.caseType === CaseType.REQUESTFORINFO
  const latestReopenData = getLatestReopenDetail(disputeDetails?.reopenDetails)
  const hideReasonForDisputing =
    disputeDetails?.originalDocumentNumber
      ?.toUpperCase()
      .startsWith(RTVS_DOC_PREFIX) &&
    disputeDetails?.reasonCodeText === RTVS_MULTIPLE_REASONS_CODE_TEXT

  const getReasonConfig = (reasonCode?: string, subReasonCode?: string) => {
    if (reasonCode === VI18_REASON_CODE) {
      return REASON_CODE_CONFIG[VI18_REASON_CODE]
    }

    if (reasonCode === VI19_REASON_CODE && subReasonCode) {
      return REASON_CODE_CONFIG[VI19_REASON_CODE]?.[subReasonCode]
    }

    return {
      editLabel: '',
      viewLabel: '',
      helperText: '',
    }
  }
  const subReasonCodeLabel =
    disputeDetails?.reasonCode === VI19_REASON_CODE ? 'Contract error type' : ''

  const reasonConfig = getReasonConfig(
    disputeDetails?.reasonCode,
    disputeDetails?.subReasonCode,
  )
  const subReasonCodeText2Label = reasonConfig.viewLabel

  return (
    <BottomBorderDiv>
      <Section labelGridSize={4} detail heading={heading} expandable>
        <SectionItem key="doc-number" label="Document #">
          {disputeDetails?.originalDocumentNumber}
        </SectionItem>
        <SectionItem
          key="case-sub-type"
          label={claimFiling ? 'Case Sub Type' : 'Deduction or Invoice Type'}
        >
          {disputeDetails?.caseSubType}
        </SectionItem>
        <SectionItem
          key="claim-doc-type"
          label={claimFiling ? 'Claim Type' : 'Claim / Doc Type'}
        >
          {disputeDetails?.documentTypeText}
        </SectionItem>
        <SectionItem
          key="claim-doc-sub-type"
          label={claimFiling ? 'Claim Sub Type' : 'Claim / Doc Sub Type'}
        >
          {disputeDetails?.documentSubTypeText}
        </SectionItem>
        {disputeDetails?.caseType === CaseType.DISPUTE &&
          disputeDetails?.caseSubType === CaseSubType.VENDOR_INCOME && (
            <>
              <SectionItem label={'Sub-contract type'}>
                {disputeDetails?.subContractType}
              </SectionItem>
              <SectionItem label={'Contract ID#'}>
                {disputeDetails?.contractId}
              </SectionItem>
            </>
          )}
        {!hideReasonForDisputing && (
          <SectionItem
            key="reason"
            label={
              claimFiling
                ? 'Reason for filing the Claim'
                : request
                  ? 'Reason for Request'
                  : 'Reason for Disputing'
            }
          >
            {disputeDetails?.reasonCodeText}
          </SectionItem>
        )}

        {disputeDetails?.caseSubType === CaseSubType.VENDOR_INCOME &&
          disputeDetails?.reasonCode === VI19_REASON_CODE && (
            <SectionItem label={subReasonCodeLabel}>
              {disputeDetails?.subReasonCodeText}
            </SectionItem>
          )}
        {disputeDetails?.caseSubType === CaseSubType.VENDOR_INCOME &&
          ((disputeDetails?.reasonCode === VI19_REASON_CODE &&
            disputeDetails?.subReasonCode !==
              VI19_SUB_REASON_CODES.PROMO_EVENT) ||
            disputeDetails?.reasonCode === VI18_REASON_CODE) && (
            <SectionItem label={subReasonCodeText2Label}>
              {disputeDetails?.subReasonCodeText2}
            </SectionItem>
          )}

        <SectionItem
          key="brief-explanation"
          label={
            claimFiling
              ? 'Brief explanation for filing the case'
              : 'Brief explanation for raising the case'
          }
        >
          {disputeDetails?.caseDescription}
        </SectionItem>
        {!isVendor && latestReopenData?.reopenReason && (
          <SectionItem key="latest-reopen-reason" label="Latest re-open reason">
            {latestReopenData.reopenReason}
          </SectionItem>
        )}
        {!isVendor && latestReopenData?.justificationForReopen && (
          <SectionItem key="latest-reopen-justification" label="Latest re-open justification">
            {latestReopenData.justificationForReopen}
          </SectionItem>
        )}
      </Section>
    </BottomBorderDiv>
  )
}

export default EditDisputeDetails
